var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "misc-wrapper" },
    [
      _c(
        "b-link",
        { staticClass: "brand-logo", attrs: { to: _vm.loginRoute() } },
        [
          _c("vuexy-logo"),
          _c("h2", { staticClass: "brand-text text-primary ml-1" }, [
            _vm._v(" 닥터인포 관리자 "),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "misc-inner p-2 p-sm-3" }, [
        _c(
          "div",
          { staticClass: "w-100 text-center" },
          [
            _c("h2", { staticClass: "mb-1" }, [
              _vm._v(" 페이지 접근 권한이 없습니다. 🔐 "),
            ]),
            _c("p", { staticClass: "mb-2" }, [
              _vm._v(
                " 현재 권한으로 접근이 불가한 페이지입니다. 메인으로 이동하세요. "
              ),
            ]),
            _c(
              "b-button",
              {
                staticClass: "mb-1 btn-sm-block",
                attrs: { variant: "primary", to: _vm.loginRoute() },
              },
              [_vm._v("메인으로 가기")]
            ),
            _c("b-img", {
              attrs: { fluid: "", src: _vm.imgUrl, alt: "Not authorized page" },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }